/*
 * Custom JavaScript
 * ===========================================================================
 *
 * Use this file to add your own custom JavaScript code.
 *
 * This file is loaded at the end of the body with the 'defer' attribute,
 * which means it will execute after the HTML document has been parsed.
 *
 * Tips:
 * - The DOM is ready when this script runs (no need for DOMContentLoaded)
 * - You can use Shopify's global objects like:
 *   - window.Shopify - Shopify global object with shop info
 *   - window.routes - Cart and search URLs
 *   - window.cartStrings - Cart-related translation strings
 *   - window.variantStrings - Product variant translation strings
 *
 * - The theme uses a pub/sub pattern for events. You can subscribe to events:
 *   - subscribe(PUB_SUB_EVENTS.cartUpdate, callback) - Cart updates
 *   - subscribe(PUB_SUB_EVENTS.quantityUpdate, callback) - Quantity changes
 *
 * - Common DOM queries:
 *   - document.querySelector('.selector') - Get single element
 *   - document.querySelectorAll('.selector') - Get all matching elements
 *
 * ===========================================================================
 */

/* Add your custom JavaScript below this line */

(() => {
  const end = Date.parse("2026-10-24T21:42:47.753Z");
  const banner = document.querySelector('[data-vr-pbf-end]');
  const clock = banner && banner.querySelector('[data-vr-pbf-clock]');
  const pad = value => String(value).padStart(2, '0');
  const update = () => {
    const left = Math.max(0, Math.ceil((end - Date.now()) / 1000));
    if (left === 0) {
      document.documentElement.classList.add('vr-pbf-ended');
      if (banner) banner.hidden = true;
      return false;
    }
    if (clock) clock.textContent = pad(Math.floor(left / 3600)) + ' h ' + pad(Math.floor(left % 3600 / 60)) + ' min ' + pad(left % 60) + ' s';
    return true;
  };
  if (update()) {
    const interval = window.setInterval(() => {
      if (!update()) window.clearInterval(interval);
    }, 1000);
    document.addEventListener('visibilitychange', update);
    window.addEventListener('pageshow', update);
  }
})();
